import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { smsLogZodObject } from "./sms-log";

const smsLogCallbackCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SMS_LOG_CALLBACK_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    data: smsLogZodObject,
});
type SmsLogCallbackCommand = z.infer<typeof smsLogCallbackCommandZodObject>;
const smsLogCallbackCommandZodScheme =
    smsLogCallbackCommandZodObject as z.ZodSchema<SmsLogCallbackCommand>;

const _factoryParamsZodObject = smsLogCallbackCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof _factoryParamsZodObject>;
const smsLogCallbackCommandFactory = (params: FactoryParams) => {
    const command: SmsLogCallbackCommand = {
        ...params,
        _id: generateId({ prefix: "set_sms_settings_command__" }),
        _type: "SMS_LOG_CALLBACK_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    smsLogCallbackCommandFactory,
    _factoryParamsZodObject as smsLogCallbackCommandFactoryParamsZodObject,
    smsLogCallbackCommandZodObject,
    smsLogCallbackCommandZodScheme,
};
export type {
    SmsLogCallbackCommand,
    FactoryParams as SmsLogCallbackCommandFactoryParams,
};
